<template>

    <div class="prop">
        <span class="prop-label" :title="label">{{ label }}</span>
        <v-value class="prop-value" :value="value" />
    </div>

</template>

<style scoped lang="scss">

    .prop {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        overflow: hidden;
        &:last-child {
            margin-bottom: 0;
        }
        .prop-label {
            @include font-medium(13px);
            color: $color-text;
            max-width: 50%;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .prop-value {
            @include font-medium(13px);
            color: $color-text-secondary;
            max-width: 50%;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

</style>

<script>

export default {

    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: [String, Number, Boolean],
            default: null,
        },
    },

    computed: {

        displayValue() {
            return this.value !== null ? this.value : 'Unknown';
        },

        classes() {
            return {
                'text-muted': this.value === null,
            }
        },

    },

}

</script>
